<template>
  <v-dialog v-model="dialog" width="1300">
    <EditarHorarioGeneral />
    <AsignarHorarioHistorico />
    <v-card>
      <v-card-title class="headline">
        <v-icon>event_note</v-icon>
        Historico de horarios 
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-tooltip bottom>
          <v-btn
            color="primary"
            dark
            @click.native.stop="crearHorarioHistorico()"
            slot="activator"
            ><v-icon dark>add</v-icon> Crear horario historico</v-btn
          >
          <span>Crear horario historico</span>
        </v-tooltip>
        <v-data-table
          :headers="headers"
          :items="lista_horarios"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          no-results-text="No se encontraron coincidencias"
          :loading="loading"
          :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
          :pagination.sync="pagination"
          rows-per-page-text="Filas por pagina"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                id="header-comprmido"
                @click="changeSort(header.value)"
              >
                <v-icon small color="blue">arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr
              :style="
                props.item.coincidencia == 0
                  ? ''
                  : 'background:rgb(250, 187, 203,0.5)'
              "
            >
              <td class="text-xs-center py-0 px-1">
                {{ props.item.descripcion_horario }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ props.item.descripcion }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ props.item.hora_inicio }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ props.item.hora_fin }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ props.item.hora_inicio2 }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ props.item.hora_fin2 }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                <!-- {{ $moment(props.item.fecha_desde).format("DD-MM-YYYY") }} -->
              </td>
              <td class="text-xs-center py-0 px-1">
                {{
                  props.item.fecha_hasta
                    ? $moment(props.item.fecha_hasta).format("DD/MM/YYYY")
                    : ""
                }}
                <!-- {{ $moment(props.item.fecha_hasta).format("DD-MM-YYYY") }} -->
              </td>

              <td
                class="text-xs-center py-0 px-1"
                style="background:#7EDDD3"
                v-if="props.item.id_estado == 1"
              >
                VIGENTE
              </td>
              <td
                class="text-xs-center py-0 px-1"
                v-if="props.item.id_estado == 2"
              >
                INACTIVO
              </td>
              <td class="text-xs-center py-0 px-1">
                <v-btn
                  color="#007DBA"
                  icon
                  title="Editar"
                  outline
                  @click="EditarHorarioGeneral(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  color="error"
                  icon
                  title="Eliminar"
                  outline
                  @click="eliminarHorario(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="close()">
          <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import EditarHorarioGeneral from "./EditarHorarioGeneral";
import AsignarHorarioHistorico from "./AsignarHorarioHistorico.vue";

export default {
  mixins: [validate],
  components: {
    EditarHorarioGeneral,
    AsignarHorarioHistorico
  },
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      dialog: false,
      user: this.$storage.get("user"),
      loading: false,
      valid: true,
      horario: {},
      horarios_especiales: [],
      lista_horarios: [],
      id_persona: null,
      form: {},
      dias: [],
      headers: [
      
        {
          text: "Descripcion horario",
          align: "center",
          value: "descripcion_horario",
          class: "px-2"
        },
        {
          text: "Tipo de horario",
          align: "center",
          value: "descripcion",
          class: "px-2"
        }, //continuo o discontinuo
        {
          text: "Hora de inicio turno 1",
          value: "hora_inicio",
          align: "center"
        },
        {
          text: "Hora final  turno 1",
          value: "hora_fin",
          align: "center"
        },
        {
          text: "Hora de inicio turno 2",
          value: "hora_inicio2",
          align: "center"
        },
        {
          text: "Hora final turno 2",
          value: "hora_fin2",
          align: "center"
        },
        {
          text: "Fecha desde",
          value: "fecha_desde",
          align: "center"
        },
        {
          text: "Fecha hasta",
          value: "fecha_hasta",
          align: "center"
        },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Acciones", value: "", align: "center" }
      ],
      horarios_cargados: []
    };
  },
  async mounted() {
    this.obtenerHorariosEspeciales();
    this.obtenerDias();

    this.$bus.$on("openDialogVerHorarioContinuoDiscontinuo", async item => {
      this.horario = item;

      this.id_persona = parseInt(item.id);
      this.dialog = true;
      await this.cargarHorarios();
    });
    this.$bus.$on("closeDialog2", async () => {
      await this.cargarHorarios();
    });
    this.$bus.$on("closeDialogAsignarHorarioHistorico", async () => {
      await this.cargarHorarios();
    });
  },
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    //Metodo para llamar al dialog de creacion de nuevo horario
    crearHorarioHistorico() {
      this.$bus.$emit(
        "openDialogAsignarHorarioHistorico",
        this.horario,
        this.lista_horarios
      );
    },
    close() {
      this.loading = false;
      this.horario = {};
      this.form = {};
      this.horarios_cargados = [];
      this.dialog = false;
      //document.location.reload();
      this.$bus.$emit("closeDialog");
    },
    async cargarListadoDeHorarios() {
      try {
      } catch (error) {
        console.log(error);
      }
    },
    async eliminarHorario(item) {
      try {
        this.$confirm("¿Está seguro de eliminar el horario?", async () => {
          let query = `select control.fn_elimina_horario_persona(${this.id_persona},${item.id_horario_persona},'${item.fecha_desde}','${item.fecha_hasta}',${this.user.id})`;
          let respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"${query}"){
                      respuesta
                    }
                  }
                `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_elimina_horario_persona;
          let res = respuesta.split("|");
          if (res[0] == "1") {
            this.$message.success();
            await this.cargarHorarios();
          } else {
            this.$message.error(res);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async cargarHorarios() {
      this.lista_horarios = [];
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              vHistoricoHorarioPersonas(id_persona:${this.id_persona}){
                rows{
                  id_estado
                  id_horario
                  descripcion
                  hora_inicio
                  hora_fin
                  hora_inicio2
                  hora_fin2
                  fecha_desde
                  fecha_hasta
                  id_persona
                  id_horario_persona
                  estato
                  descripcion_horario
                }
              }
            }
          `
        });
        let lista_tmp = res.vHistoricoHorarioPersonas.rows;
        console.log('lista_tmp..',lista_tmp);
        // Buscamos choque de horarios, si es 0 no hay coincidencia, si hay mas de 0 hay coindcidencia
        lista_tmp.forEach(element => {
          element.coincidencia = lista_tmp.filter(
            horario =>
              horario.id_horario_persona != element.id_horario_persona &&
              ((this.$moment(element.fecha_desde) >=
                this.$moment(horario.fecha_desde) &&
                this.$moment(element.fecha_desde) <=
                  this.$moment(horario.fecha_hasta)) ||
                (this.$moment(element.fecha_hasta) >=
                  this.$moment(horario.fecha_desde) &&
                  this.$moment(element.fecha_hasta) <=
                    this.$moment(horario.fecha_hasta)))
          ).length;
        });
        this.lista_horarios = lista_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    obtieneNombreHorarioEspecial(id) {
      const found = this.horarios_especiales.find(
        element => element.id == parseInt(id)
      );
      return found.descripcion;
    },
    obtieneNombreDia(id) {
      const found = this.dias.find(element => element.id == parseInt(id));
      return found.valor.split("-")[1];
    },
    async obtenerHorariosEspeciales() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              estados(tipo: "horario_especial"){
                rows{
                  id
                  descripcion
                }
              }
            }
          `
        });
        this.horarios_especiales = res.estados.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerDias() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              params(tipo: "dia"){
                rows{
                  id
                  valor
                }
              }
            }
          `
        });
        this.dias = res.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    adicionarHorarioEspecial() {
      if (this.$refs.form.validate()) {
        const data = {
          hora_inicio: this.form.hora_inicio,
          hora_fin: this.form.hora_fin,
          id_estado: 1,
          id_parametro_dia: this.form.id_parametro_dia,
          fecha_desde: this.form.fecha_desde,
          fecha_hasta: this.form.fecha_hasta,
          id_horario_especial: this.form.id_horario_especial
        };
        this.horarios_cargados.push(data);
      }
    },
    EditarHorarioGeneral(item) {
      let dato = this.horario;
      dato.fecha_hasta = item.fecha_hasta;
      if (!item.hora_inicio2) {
        dato.continuo_discontinuo = "1";
      } else {
        dato.continuo_discontinuo = "2";
      }

      this.$bus.$emit("openDialogEditarHorarioGeneral", item);
    }
  }
};
</script>

<style scoped>
#header-comprmido {
  background: rgb(180, 218, 233);
  white-space: pre-line;
  padding: 0em 0.5em 0em 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/VerHorarioContinuoDiscontinuo.vue